import React, { useState, useEffect, useRef } from 'react';
import '../../spinner.css';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../../spinner.css';
import { useNavigate } from 'react-router-dom';
import { getUserDetails } from '../../services/UserService';
import { getPedagogyData, postLearning, getUserPedagogyLearningData } from '../../services/LearningService';
import { getCurrentUTCTimestamp } from '../../services/Utils';
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import moment from 'moment';
import Vimeo from '@u-wave/react-vimeo';
import Loader from '../../utility/Loader';
import SurveyPopup from './SurveyPopup';
import { getActiveSurveyQuestionWithId, addSurveyAnswer } from '../../services/Survey';
import { getNotes, addNotes, updateNotes, getVimeoSubtitles, addOrUpdateFeedback, getUserLikenesss } from '../../services/LearningService';

export default function LearnerTheory() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [pedagogy, setPedagogy] = useState([]);
    const [pedagogyLearning, setPedagogyLearning] = useState([]);
    const [module, setModule] = useState({});
    const [startTs, setStartTs] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [showTimer, setShowTimer] = useState(false);
    const [remainingTime, setRemainingTime] = useState(null);
    const currentTime = useRef(null);
    const prevTime = useRef(null);
    const isNewTimeFirstTick = useRef(false);
    const swiperRef = useRef(null);
    const [shakeActive, setShakeActive] = useState(true);
    const [viewMode, setViewMode] = useState("thumbnail");
    const [fullView, setFullView] = useState(0);
    const [transcript, setTranscript] = useState([]);
    const [videoIndex, setVideoIndex] = useState(0);
    const [numOfTimes, setNumOfTimes] = useState(false);
    const [showFeedback, setShowFeedback] = useState(false);
    const feedbackRef = useRef(null);
    const [selectedFeedback, setSelectedFeedback] = useState(null);
    const [popupVisible, setPopupVisible] = useState(false);
    const [resolvePopup, setResolvePopup] = useState(null);
    const [allSurvey, setAllSurvey] = useState([]);
    const [feedback, setFeedback] = useState("");
    const [notes, setNotes] = useState([]);
    const [selectedNote, setSelectedNote] = useState({ notes: "" });

    useEffect(() => {
        setStartTs(moment.utc());
        const userDetails = getUserDetails();
        if (userDetails.token === undefined) {
            navigate('/login');
        } else {

            const isAlreadySentHi = sessionStorage.getItem('qBotHi');
            if (isAlreadySentHi === undefined || isAlreadySentHi === null || isAlreadySentHi !== userDetails.user.first_name) {
                const dfMessenger = document.querySelector('df-messenger');
                dfMessenger.renderCustomText('Hello ' + userDetails.user.first_name + ', I am your friendly assistant. Let us make your learning journey seamless and enjoyable! Just type your question, and I will provide you with the information you need. Happy learning!', true);
                sessionStorage.setItem('qBotHi', userDetails.user.first_name);
            }
            getPedagogy();
        }
        const timer = setTimeout(() => {
            setShakeActive(false);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        if (showFeedback) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showFeedback]);

    const renderTime = ({ remainingTime }) => {
        if (currentTime.current !== remainingTime) {
            isNewTimeFirstTick.current = true;
            prevTime.current = currentTime.current;
            currentTime.current = remainingTime;
        } else {
            isNewTimeFirstTick.current = false;
        }

        // force one last re-render when the time is over to trigger the last animation
        if (remainingTime === 0) {
            setTimeout(() => {
                setRemainingTime((val) => (val === null ? 0 : val - 1));
            }, 20);
        }

        const isTimeUp = isNewTimeFirstTick.current;

        return (
            <div className="time-wrapper">
                <div key={remainingTime} className={`time ${isTimeUp ? 'up' : ''}`}>
                    {remainingTime}
                </div>
                {prevTime.current !== null && (
                    <div
                        key={prevTime.current}
                        className={`time ${!isTimeUp ? 'down' : ''}`}
                    >
                        {prevTime.current}
                    </div>
                )}
            </div>
        );
    };

    const handleTimerEnd = () => {
        setShowTimer(false);
        if (selectedIndex + 1 < pedagogy.length) {
            nextPedagogy(selectedIndex + 1);
        }
    }

    const handleRepeat = () => {
        setShowTimer(false);
        nextPedagogy(selectedIndex);

    }

    const nextAutoPedagogy = async (idx) => {
        //setShowTimer(true);
        if (idx + 1 < pedagogy.length) {
            nextPedagogy(idx + 1);
        }

    };

    const downloadSubtitle = async (link, lang, i) => {
        const response = await fetch(link);
        const blob = await response.blob();
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${pedagogy[selectedIndex].title}_${i}_${lang}.vtt`;
        a.click();
        URL.revokeObjectURL(url);
    };

    const getVimeoSubtitleData = async (pedagogy) => {
        const video_id = await extractVimeoId(pedagogy.url);

        const userDetails = getUserDetails();
        let resp = await getVimeoSubtitles(userDetails.token, video_id);

        if (resp["error"] === false) {
            setTranscript(resp.data);
        } else {
            // toast.error("Some error occurred while adding note!");
        }
        await getFeedback(pedagogy);

    };

    const addNote = async () => {
        const userDetails = getUserDetails();
        let obj = { course_id: module.course_id, module_id: module.module_id, pedagogy_id: pedagogy[selectedIndex].id, cohort_id: userDetails.user.cohort_id, notes: selectedNote.notes }
        let resp = await addNotes(userDetails.token, obj);
        if (resp["error"] === false) {
            toast.success("Node added!");
            setSelectedNote({ notes: "" });
            await getAllNotes(pedagogy[selectedIndex].id);
        } else {
            toast.error("Some error occurred while adding note!");
        }
    };

    const getAllNotes = async (pedagogy_id) => {
        const userDetails = getUserDetails();
        let resp = await getNotes(userDetails.token, pedagogy_id);
        if (resp["error"] === false) {
            setNotes(resp.data);
        } else {
            // toast.error("Some error occurred while adding note!");
        }

    };

    const extractVimeoId = async (url) => {
        const match = url.match(/vimeo\.com\/(\d+)/);
        return match ? match[1] : null;
    };

    const getFeedback = async (pedagogy) => {
        const userDetails = getUserDetails();
        if (pedagogy.id !== undefined && pedagogy.id !== null) {
            let resp = await getUserLikenesss(userDetails.token, pedagogy.id);

            if (resp["error"] === false && resp.data.length > 0) {
                let data = resp.data[0];
                if (data.likeness === true) {
                    setSelectedFeedback('likeness');
                } else if (data.dislikeness === true) {
                    setSelectedFeedback('dislikeness');
                }

            } else {
                setSelectedFeedback(null);
            }
        } else {
            setSelectedFeedback(null);
        }
    };

    const goToSlide = (index) => {
        if (swiperRef.current) {
            swiperRef.current.swiper.slideTo(index);
        }
    };

    const resetFullView = () => {
        fullView === 0 ? setFullView(1) : setFullView(0);
    };

    const handleVideoEnd = () => {
        nextAutoPedagogy(selectedIndex);

    };

    const getActiveSurveyQuestionWithIdData = async () => {
        const userDetails = getUserDetails();

        let module_id = module.module_id;
        let resp = await getActiveSurveyQuestionWithId(userDetails.token, "module_id", module_id);
        if (resp.error === false && resp.data.length > 0) {
            setAllSurvey(resp.data);
            const inputValue = await showPopup();
            if (inputValue.length > 0) {
                let allObj = [];
                for (let i = 0; i < inputValue.length; i++) {
                    allObj.push({ survey_id: inputValue[i].id, user_id: userDetails.user.id, customer_id: userDetails.user.customer_id, user_answer: inputValue[i].answer, cohort_id: userDetails.user.cohort_id });
                }
                let resp1 = await addSurveyAnswer(userDetails.token, allObj);
                if (resp1.error === false) {
                    toast.success("Thank you for your feedback");
                } else {
                    toast.error("Some error occurred while recording your feedback");
                }
            }
        }
    };

    const showPopup = () => {
        return new Promise((resolve) => {
            setResolvePopup(() => resolve);
            setPopupVisible(true);
        });
    };

    const handleClose = (value) => {
        setPopupVisible(false);
        setAllSurvey([]);
        if (resolvePopup) {
            resolvePopup(value);
            setResolvePopup(null);
        }
    };

    const getPedagogy = async () => {
        const userDetails = getUserDetails();
        let module = sessionStorage.getItem('currentModule') !== undefined ? JSON.parse(sessionStorage.getItem('currentModule')) : {};
        setModule(module);
        let module_id = module.module_id;
        if (module_id !== undefined) {
            setLoading(true);
            const pedagogyData = await getPedagogyData(userDetails.token, module_id);
            if (pedagogyData.error) {
                toast.error("No Pedogogy Found!");
                setPedagogy([]);
            } else if (pedagogyData.data.length > 0) {
                setPedagogy(pedagogyData.data);
                await getUserPedagogyLearning(module_id, userDetails.token, pedagogyData.data);
                let pedagogySelected = sessionStorage.getItem('currentPedagogy') !== undefined ? JSON.parse(sessionStorage.getItem('currentPedagogy')) : {};
                let index = 0;
                if (pedagogySelected !== null && pedagogySelected !== undefined && pedagogySelected.index !== undefined) {
                    sessionStorage.removeItem('currentPedagogy');

                    if (pedagogyData.data.length > pedagogySelected.index + 1) {
                        index = pedagogySelected.index + 1;
                    }
                }
                setSelectedIndex(index);
                await addLearning(module, 0, pedagogyData.data);
                await getVimeoSubtitleData(pedagogyData.data[index]);
                await getAllNotes(pedagogyData.data[index].id);
            } else {
                setPedagogy(pedagogyData.data);
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // Optional smooth scrolling animation
            });
            setLoading(false);
        } else {
            setPedagogy([]);
            toast.info("No Pedogogy Found!");
            navigate('/learner/courses');
        }
    };

    const getUserPedagogyLearning = async (module_id, token, pedagogy_data) => {
        const pedagogyLearningData = await getUserPedagogyLearningData({ 'module_id': module_id }, token);
        if (pedagogyLearningData.error) {
            setPedagogyLearning({});
        } else {
            let data = pedagogyLearningData.data;
            let learningMap = {};
            for (let i = 0; i < data.length; i++) {
                learningMap[data[i].pedagogy_id] = 1;
            }
            learningMap[pedagogy_data[0].id] = 1;
            setPedagogyLearning(learningMap);

        }

    };

    const getNextModule = async () => {
        await addLearning(module, selectedIndex, pedagogy);
        await getActiveSurveyQuestionWithIdData();
        let courses = sessionStorage.getItem('modules') !== undefined ? JSON.parse(sessionStorage.getItem('modules')).courses : [];
        for (let i = 0; i < courses.length; i++) {
            if (module.course_id === courses[i].course_id) {
                let allModules = courses[i].modules;
                let foundNextModule = false;
                for (let j = 0; j < allModules.length; j++) {
                    if (parseInt(module.module_seq_no) + 1 === parseInt(allModules[j].module_seq_no)) {
                        foundNextModule = true;
                        let currentModule = Object.assign(allModules[j]);
                        currentModule['course_id'] = courses[i].course_id;
                        currentModule['course_code'] = courses[i].course_code;
                        currentModule['course_name'] = courses[i].course_name;
                        currentModule['course_desc'] = courses[i].course_desc;
                        currentModule['color'] = courses[i].color;
                        setModule(currentModule);
                        sessionStorage.setItem("currentModule", JSON.stringify(currentModule));
                        if (currentModule.module_type === 'ASSESSMENT') {
                            navigate('/learner/assessment');
                        } else if (currentModule.module_type === 'THEORY' || currentModule.module_type === 'APPLICATION') {
                            await getPedagogy();
                        } else if (currentModule.module_type === "GAME") {
                            navigate('/learner/game');
                        }
                    }
                }
                if (!foundNextModule) {
                    navigate('/learner/courses');
                }
            }
        }

    };

    const getPrevModule = async () => {
        await addLearning(module, selectedIndex, pedagogy);
        await getActiveSurveyQuestionWithIdData();
        let courses = sessionStorage.getItem('modules') !== undefined ? JSON.parse(sessionStorage.getItem('modules')).courses : [];
        for (let i = 0; i < courses.length; i++) {
            if (module.course_id === courses[i].course_id) {
                let allModules = courses[i].modules;
                for (let j = 0; j < allModules.length; j++) {
                    if (parseInt(module.module_seq_no) - 1 === parseInt(allModules[j].module_seq_no)) {
                        let currentModule = Object.assign(allModules[j]);
                        currentModule['course_id'] = courses[i].course_id;
                        currentModule['course_code'] = courses[i].course_code;
                        currentModule['course_name'] = courses[i].course_name;
                        currentModule['course_desc'] = courses[i].course_desc;
                        currentModule['color'] = courses[i].color;
                        setModule(currentModule);
                        sessionStorage.setItem("currentModule", JSON.stringify(currentModule));
                        if (currentModule.module_type === 'ASSESSMENT') {
                            navigate('/learner/assessment');
                        } else if (currentModule.module_type === 'THEORY') {
                            await getPedagogy();
                        } else if (currentModule.module_type === "GAME") {
                            navigate('/learner/game');
                        }
                        else if (currentModule.module_type === 'APPLICATION') {
                            navigate('/learner/application');
                        }
                    }
                }
            }
        }
    };

    const addLearning = async (module, idx, pedagogies) => {
        if (pedagogies.length > 0) {
            let currentTs = moment.utc();
            let secs = currentTs.diff(startTs, "seconds");
            setStartTs(currentTs);
            const userDetails = getUserDetails();
            let objectToSend = { module_id: module.module_id, pedagogy_id: pedagogies[idx].id, learning_sec: secs, cohort_id: userDetails.user.cohort_id };
            const resp = await postLearning(userDetails.token, objectToSend);
            if (resp.error) {
            }
        }

    };

    const nextPedagogy = async (idx) => {
        setLoading1(true);
        await addLearning(module, selectedIndex, pedagogy);
        await addLearning(module, idx, pedagogy);
        setSelectedIndex(idx);
        if (pedagogy[idx].pedagogy_type === 'ASSESSMENT') {
            if (pedagogy[idx]["pedagogy_type"] === 'ASSESSMENT') {
                let obj = Object.assign(pedagogy[idx]);
                obj['index'] = idx;
                obj['type'] = "thumbnail";

                sessionStorage.setItem('currentModule', JSON.stringify(module));
                sessionStorage.setItem('currentPedagogy', JSON.stringify(obj));

                navigate('/learner/kc');
                return;
            }
        }
        let updatedLearning = { ...pedagogyLearning };
        updatedLearning[pedagogy[idx].id] = 1;
        setPedagogyLearning(updatedLearning);
        await new Promise(resolve => setTimeout(resolve, 1000));
        goToSlide(idx);
        await getVimeoSubtitleData(pedagogy[idx]);
        await getAllNotes(pedagogy[idx].id);
        setLoading1(false);
    };

    const changeViewMode = async (type) => {
        setViewMode(type);
        if (type === 'list') {
            navigate('/learner/video');
        }
    };

    const handleClickOutside = (event) => {
        if (feedbackRef.current && !feedbackRef.current.contains(event.target)) {
            setShowFeedback(false);
        }
    };

    const addFeeback = async (type) => {
        if (type !== 'feedback') {
            setSelectedFeedback(type);
        }
        let obj = {};
        if (type === 'likeness') {
            obj = { type: 'likeness', data: true, pedagogy_id: pedagogy[selectedIndex].id, module_id: pedagogy[selectedIndex].module_id }
        } else if (type === 'dislikeness') {
            obj = { type: 'dislikeness', data: true, pedagogy_id: pedagogy[selectedIndex].id, module_id: pedagogy[selectedIndex].module_id }
        } else if (type === 'feedback') {
            obj = { type: 'feedback', data: feedback, pedagogy_id: pedagogy[selectedIndex].id, module_id: pedagogy[selectedIndex].module_id }
            setFeedback('');
        }
        if (obj['type'] !== undefined && obj['type'] !== null) {
            const userDetails = getUserDetails();
            obj['cohort_id'] = userDetails.user.cohort_id;
            let resp = await addOrUpdateFeedback(userDetails.token, obj);
            if (resp.error === false) {
                //toast.info("Feedback taken successfully!");
            } else {
                toast.error("Some Error occurred! Please try again after some time");
            }
        }
    };

    const handleFeedbackChange = (e) => {
        const { name, value } = e.target;
        setFeedback(value);
    };

    const handleValueChange = (e) => {

        const { name, value } = e.target;
        setSelectedNote({
            ...selectedNote,
            [name]: value,
        });
    };

    return (
        <>
            <div>
                {loading ? (
                    <Loader />
                ) : (
                    <div className='py-10'>
                        <div className='lg:px-12 px-6 lg:pb-2 pb-1 md:border-b-2 md:border-[#D0D0D0]'>
                            <h3 className='text-2xl text-secondary inter-700 mb-3 lg:hidden'>{module.course_name}</h3>
                            <div className='beardcrumb-wrap mb-5'>
                                <ul className='flex flex-wrap items-center'>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>My Courses</a>
                                    </li>
                                    <li className='prev-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        <a href='/learner/courses'>{module.course_name}</a>
                                    </li>
                                    <li className='current-page text-sm lg:text-lg inter-400 relative lg:mr-6 mr-4'>
                                        Lesson {module.module_seq_no}
                                    </li>
                                </ul>
                            </div>
                            <div className='course-heading-wrap lg:mb-6 mb-5 flex items-center justify-between'>
                                {/* <h3 className='text-tertiary text-xl lg:text-2xl inter-500 mb-1'>Lesson {module.module_seq_no}</h3> */}
                                <h2 className='text-[#1D548D] text-2xl inter-500'>{module.module_desc}</h2>
                                <div className="course-video-toggle flex items-center bg-[#D0D0D0] rounded-lg">
                                    <button onClick={() => changeViewMode('thumbnail')} title="Switch to Grid View" className={`grid-view w-10 h-10 cursor-pointer flex items-center justify-center rounded-lg ${viewMode === 'thumbnail' ? 'bg-secondary thumb-selected' : 'bg-[#D0D0D0]'}`} aria-label='grid view video' tabIndex={0}>
                                        <svg fill="#000000" width="20px" height="20px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <rect class="clr-i-solid clr-i-solid-path-1" x="4" y="4" width="12" height="12" rx="2" ry="2"></rect><rect class="clr-i-solid clr-i-solid-path-2" x="20" y="4" width="12" height="12" rx="2" ry="2"></rect><rect class="clr-i-solid clr-i-solid-path-3" x="4" y="20" width="12" height="12" rx="2" ry="2"></rect><rect class="clr-i-solid clr-i-solid-path-4" x="20" y="20" width="12" height="12" rx="2" ry="2"></rect>
                                            <rect x="0" y="0" width="36" height="36" fill-opacity="0" />
                                        </svg>
                                    </button>
                                    <button onClick={() => changeViewMode('list')} title="Switch to List View" className={`list-view w-10 h-10 cursor-pointer flex items-center justify-center rounded-lg ${viewMode === 'list' ? 'bg-secondary list-selected' : 'bg-[#D0D0D0]'}`} aria-label='list view video' tabIndex={0}>
                                        <svg width="20px" height="20px" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg">
                                            <path d="m 2 1 c -0.554688 0 -1 0.445312 -1 1 v 2 c 0 0.554688 0.445312 1 1 1 h 2 c 0.554688 0 1 -0.445312 1 -1 v -2 c 0 -0.554688 -0.445312 -1 -1 -1 z m 5 1 v 2 h 8 v -2 z m -5 4.015625 c -0.554688 0 -1 0.445313 -1 1 v 1.980469 c 0 0.550781 0.445312 1 1 1 h 2 c 0.554688 0 1 -0.449219 1 -1 v -1.980469 c 0 -0.554687 -0.445312 -1 -1 -1 z m 5 0.984375 v 2 h 8 v -2 z m -5 4 c -0.554688 0 -1 0.445312 -1 1 v 1.980469 c 0 0.550781 0.445312 1 1 1 h 2 c 0.554688 0 1 -0.449219 1 -1 v -1.980469 c 0 -0.554688 -0.445312 -1 -1 -1 z m 5 0.984375 v 2 h 8 v -2 z m 0 0" fill="#2e3436" />
                                        </svg>
                                    </button>
                                </div>
                            </div>

                        </div>
                        {pedagogy.length === 0 ? (
                            <div className='lg:pt-10 pt-0 lg:px-12 px-6 pb-8 border-b-2 border-[#D0D0D0]'>
                                <h4 className='text-lg text-bold inter-400 mb-4'>Nothing to learn in this module.</h4>
                            </div>
                        ) : (
                            <>
                                {(loading1 || showTimer) ? (
                                    <>
                                        {loading1 ? (
                                            <div className="spinner-container lg:pt-10 pt-0 pb-8 border-b-2 border-[#D0D0D0]">
                                                {/* <img src='images/play-icon.svg' alt='GIF' /> */}
                                                <div className='lg:px-12 w-full'>
                                                    <div className='w-full h-[300px] lg:h-[460px] 2xl:h-[520px] bg-black'></div>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className='px-0 lg:px-12'>
                                                <div className="timer-wrapper lg:mt-10 mt-8 items-center relative w-full h-[200px] md:h-[430px] lg:h-[650px] bg-[#eee]">
                                                    <div className='vdo-rply-btn-wrap flex justify-center mr-4 md:mr-6'>
                                                        <button onClick={() => handleRepeat()} className='video-replay-btn w-20 h-12 rounded-full flex items-center justify-center'>
                                                            <img className='max-h-full transition-transform duration-1000' src='../images/replay-icon.svg' alt='replay icon' />
                                                        </button>
                                                    </div>
                                                    <CountdownCircleTimer
                                                        isPlaying
                                                        duration={1}
                                                        colors={["#F7B801", "#A30000", "#A30000"]}
                                                        colorsTime={[3, 2, 1]}
                                                        onComplete={handleTimerEnd}
                                                    >
                                                        {renderTime}
                                                    </CountdownCircleTimer>
                                                    <div className='vdo-next-btn-wrap flex justify-center ml-4 md:ml-6'>
                                                        <button onClick={() => handleTimerEnd()} className='video-next-btn w-20 h-12 rounded-full flex items-center justify-center transition-transform duration-1000'>
                                                            <img className='max-h-full' src='../images/next-icon.svg' alt='next icon' />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>

                                ) : (
                                    <div className='lg:pt-10 pt-0 pb-8 border-b-2 border-[#D0D0D0]'>
                                        <div className='course-vdo-wrap lg:px-12'>
                                            <div className='course-vdo-list-row flex flex-wrap'>
                                                <div className='course-vdo-box w-full lg:w-[70%]'>
                                                    <div className='video-box w-full bg-black'>
                                                        <div className='relative'>
                                                            <Vimeo
                                                                key={pedagogy[selectedIndex].url}
                                                                video={pedagogy[selectedIndex].url}
                                                                width={640}
                                                                height={360}
                                                                responsive
                                                                onEnd={handleVideoEnd}
                                                                autoplay
                                                                dnt={true}
                                                                params={{
                                                                    title: 0,
                                                                    byline: 0,
                                                                    portrait: 0,
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='course-vdo-list-wrap w-full lg:w-[30%] bg-black p-8'>
                                                    <div className='crse-vdo-list-hdng pb-4 border-b border-[#B9B9B9] flex items-center justify-between'>
                                                        <p className='text-2xl text-white'>Overview</p>
                                                    </div>
                                                    <div className='crse-video-accordion transition-all duration-500 ease-in-out transform'>
                                                        <div className=''>
                                                            <h4 className='text-xl text-white inter-700 mt-4'>{pedagogy[selectedIndex].pedagogy_seq_no}. {pedagogy[selectedIndex].title}</h4>
                                                            {pedagogy[selectedIndex].text !== undefined && pedagogy[selectedIndex].text !== '' && pedagogy[selectedIndex].text !== null ? (
                                                                <>
                                                                    {fullView === undefined || fullView === 0 ? (
                                                                        <>
                                                                            <p className='text-base inter-400 text-justify text-white mt-4' dangerouslySetInnerHTML={{ __html: pedagogy[selectedIndex].text.substring(0, 300) }} />
                                                                            <p>
                                                                                <button onClick={() => resetFullView()} className='cursor-pointer text-white underline underline-offset-2' aria-label='Show More'>Show More</button>
                                                                            </p>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <p className='text-base inter-400 text-justify text-white mt-4' dangerouslySetInnerHTML={{ __html: pedagogy[selectedIndex].text }} />
                                                                            <p>
                                                                                <button onClick={() => resetFullView()} className='cursor-pointer text-white underline underline-offset-2' aria-label='Show Less'>Show Less</button>
                                                                            </p>
                                                                        </>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                null
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <Tabs>
                                                <div className='crse-video-tabs-wrap bg-[#E6E6E6] md:pt-5 pt-0 relative'>
                                                    <div className='md:absolute md:right-3 pt-3 md:pt-0 pl-6 md:pl-0 md:top-1/2 md:-translate-y-1/2 w-[320px] 2xl:w-[430px] flex items-center' ref={feedbackRef}>
                                                        <div className='video-action-row flex items-center mt-2 mb-1'>
                                                            <div className='video-action-sngle mr-4'>
                                                                {/* Add selected class on click of button */}
                                                                <button onClick={() => addFeeback("likeness")} title='Like' className={`video-action-btn btn-like hover:-translate-y-1.5 transition duration-300 ${selectedFeedback === "likeness" ? "selected" : ""}`} aria-label='Like'>
                                                                    <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M12.444 1.35396C11.6474 0.955692 10.6814 1.33507 10.3687 2.16892L7.807 9.00001L4 9.00001C2.34315 9.00001 1 10.3432 1 12V20C1 21.6569 2.34315 23 4 23H18.3737C19.7948 23 21.0208 22.003 21.3107 20.6119L22.9773 12.6119C23.3654 10.7489 21.9433 9.00001 20.0404 9.00001H14.8874L15.6259 6.7846C16.2554 4.89615 15.4005 2.8322 13.62 1.94198L12.444 1.35396ZM9.67966 9.70225L12.0463 3.39119L12.7256 3.73083C13.6158 4.17595 14.0433 5.20792 13.7285 6.15215L12.9901 8.36755C12.5584 9.66261 13.5223 11 14.8874 11H20.0404C20.6747 11 21.1487 11.583 21.0194 12.204L20.8535 13H17C16.4477 13 16 13.4477 16 14C16 14.5523 16.4477 15 17 15H20.4369L20.0202 17H17C16.4477 17 16 17.4477 16 18C16 18.5523 16.4477 19 17 19H19.6035L19.3527 20.204C19.2561 20.6677 18.8474 21 18.3737 21H8V10.9907C8.75416 10.9179 9.40973 10.4221 9.67966 9.70225ZM6 11H4C3.44772 11 3 11.4477 3 12V20C3 20.5523 3.44772 21 4 21H6V11Z" fill="#0F0F0F" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            <div className='video-action-sngle mr-4'>
                                                                <button onClick={() => addFeeback("dislikeness")} title='Dislike' className={`video-action-btn btn-dislike hover:-translate-y-1.5 transition duration-300 ${selectedFeedback === "dislikeness" ? "selected" : ""}`} aria-label='Dislike'>
                                                                    <svg width="30px" height="30px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M11.556 22.646C12.3525 23.0443 13.3186 22.6649 13.6313 21.8311L16.193 15L20 15C21.6568 15 23 13.6569 23 12L23 4C23 2.34315 21.6568 1 20 1L5.62625 1C4.20523 1 2.97914 1.99698 2.68931 3.38814L1.02265 11.3881C0.634535 13.2511 2.05665 15 3.95959 15H9.11255L8.37409 17.2154C7.7446 19.1039 8.59952 21.1678 10.38 22.058L11.556 22.646ZM14.3203 14.2978L11.9537 20.6088L11.2744 20.2692C10.3842 19.8241 9.95671 18.7921 10.2715 17.8479L11.0099 15.6325C11.4416 14.3374 10.4777 13 9.11256 13H3.95959C3.32527 13 2.85124 12.417 2.98061 11.7961L3.14645 11L6.99998 11C7.55226 11 7.99998 10.5523 7.99998 10C7.99998 9.44772 7.55226 9.00001 6.99998 9.00001L3.56312 9.00001L3.97978 7.00001L6.99998 7.00001C7.55226 7.00001 7.99998 6.55229 7.99998 6.00001C7.99998 5.44772 7.55226 5.00001 6.99998 5.00001L4.39645 5.00001L4.64727 3.79605C4.74388 3.33233 5.15258 3 5.62625 3L16 3L16 13.0093C15.2458 13.0821 14.5903 13.5779 14.3203 14.2978ZM18 13H20C20.5523 13 21 12.5523 21 12L21 4C21 3.44772 20.5523 3 20 3L18 3L18 13Z" fill="#0F0F0F" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                            <div className='video-action-sngle'>
                                                                <button className='video-action-btn btn-feedback hover:-translate-y-1.5 transition duration-300' title='Feedback' onClick={() => setShowFeedback((prev) => !prev)} aria-label='Feedback'>
                                                                    <svg width="30px" height="30px" viewBox="2.5 2 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9.0001 8.517C8.58589 8.517 8.2501 8.85279 8.2501 9.267C8.2501 9.68121 8.58589 10.017 9.0001 10.017V8.517ZM16.0001 10.017C16.4143 10.017 16.7501 9.68121 16.7501 9.267C16.7501 8.85279 16.4143 8.517 16.0001 8.517V10.017ZM9.8751 11.076C9.46089 11.076 9.1251 11.4118 9.1251 11.826C9.1251 12.2402 9.46089 12.576 9.8751 12.576V11.076ZM15.1251 12.576C15.5393 12.576 15.8751 12.2402 15.8751 11.826C15.8751 11.4118 15.5393 11.076 15.1251 11.076V12.576ZM9.1631 5V4.24998L9.15763 4.25002L9.1631 5ZM15.8381 5L15.8438 4.25H15.8381V5ZM19.5001 8.717L18.7501 8.71149V8.717H19.5001ZM19.5001 13.23H18.7501L18.7501 13.2355L19.5001 13.23ZM18.4384 15.8472L17.9042 15.3207L17.9042 15.3207L18.4384 15.8472ZM15.8371 16.947V17.697L15.8426 17.697L15.8371 16.947ZM9.1631 16.947V16.197C9.03469 16.197 8.90843 16.23 8.79641 16.2928L9.1631 16.947ZM5.5001 19H4.7501C4.7501 19.2662 4.89125 19.5125 5.12097 19.6471C5.35068 19.7817 5.63454 19.7844 5.86679 19.6542L5.5001 19ZM5.5001 8.717H6.25012L6.25008 8.71149L5.5001 8.717ZM6.56175 6.09984L6.02756 5.5734H6.02756L6.56175 6.09984ZM9.0001 10.017H16.0001V8.517H9.0001V10.017ZM9.8751 12.576H15.1251V11.076H9.8751V12.576ZM9.1631 5.75H15.8381V4.25H9.1631V5.75ZM15.8324 5.74998C17.4559 5.76225 18.762 7.08806 18.7501 8.71149L20.2501 8.72251C20.2681 6.2708 18.2955 4.26856 15.8438 4.25002L15.8324 5.74998ZM18.7501 8.717V13.23H20.2501V8.717H18.7501ZM18.7501 13.2355C18.7558 14.0153 18.4516 14.7653 17.9042 15.3207L18.9726 16.3736C19.7992 15.5348 20.2587 14.4021 20.2501 13.2245L18.7501 13.2355ZM17.9042 15.3207C17.3569 15.8761 16.6114 16.1913 15.8316 16.197L15.8426 17.697C17.0201 17.6884 18.1461 17.2124 18.9726 16.3736L17.9042 15.3207ZM15.8371 16.197H9.1631V17.697H15.8371V16.197ZM8.79641 16.2928L5.13341 18.3458L5.86679 19.6542L9.52979 17.6012L8.79641 16.2928ZM6.2501 19V8.717H4.7501V19H6.2501ZM6.25008 8.71149C6.24435 7.93175 6.54862 7.18167 7.09595 6.62627L6.02756 5.5734C5.20098 6.41216 4.74147 7.54494 4.75012 8.72251L6.25008 8.71149ZM7.09595 6.62627C7.64328 6.07088 8.38882 5.75566 9.16857 5.74998L9.15763 4.25002C7.98006 4.2586 6.85413 4.73464 6.02756 5.5734L7.09595 6.62627Z" fill="#0F0F0F" />
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                        {showFeedback && (
                                                            <div className="video-feedback mb-0 ml-3 2xl:w-[280px]">
                                                                <textarea name="feeback" value={feedback} onChange={handleFeedbackChange} className="inter-400 text-black text-xs border border-[#bbb] focus:border-[#B44D71] rounded-md h-12 outline-0 w-full py-1.5 px-1.5 transition duration-300"></textarea>
                                                                <button onClick={() => addFeeback("feedback")} type="button" className='w-full md:w-auto bg-secondary hover:bg-black flex items-center justify-center px-4 h-6 2xl:h-7 text-white inter-500 text-xs rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label='Submit'>Submit</button>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div className='crse-video-tabs-row lg:w-3/5 mx-auto px-6 lg:px-0'>
                                                        <TabList>
                                                            <Tab aria-label="Take Notes">
                                                                <div className='flex items-center'>
                                                                    <span className='crse-video-tab-icon mr-3 w-10'>
                                                                        <img src='../images/video-notes.svg' alt='note' />
                                                                    </span>
                                                                    <span className='crse-video-tab-name text-lg text-black'>
                                                                        Take Notes
                                                                    </span>
                                                                </div>
                                                            </Tab>
                                                            <Tab aria-label="Transcript">
                                                                <div className='flex items-center'>
                                                                    <span className='crse-video-tab-icon mr-3 w-10'>
                                                                        <img src='../images/video-transcript.svg' alt='transcript' />
                                                                    </span>
                                                                    <span className='crse-video-tab-name text-lg text-black'>
                                                                        Transcript
                                                                    </span>

                                                                </div>
                                                            </Tab>
                                                        </TabList>
                                                    </div>
                                                </div>
                                                <div className='crse-video-tabs-panel-wrap py-10 px-6 lg:px-0'>
                                                    <div className='crse-video-tabs-panel-box lg:w-3/5 mx-auto'>
                                                        <TabPanel>
                                                            <div className='crse-video-cntnt-note'>
                                                                <h3 className='text-xl font-bold text-black mb-1'>{notes.length} Notes Saved</h3>
                                                                <Tabs>
                                                                    <div className='crse-note-tabs mb-6'>
                                                                        <TabList>
                                                                            {notes.map((value, index) => (
                                                                                <Tab key={value.id} aria-label={`Note ${index}`}>Note {index}</Tab>
                                                                            ))}
                                                                        </TabList>
                                                                    </div>
                                                                    <div className='crse-note-cntnt'>
                                                                        {notes.map((value, index) => (
                                                                            <TabPanel key={value.id}>
                                                                                <div className='crse-note-old'>
                                                                                    <p className='crse-note-old-text text-base 2xl:text-lg text-black'>{value.notes}</p>
                                                                                </div>
                                                                            </TabPanel>
                                                                        ))}

                                                                    </div>
                                                                </Tabs>
                                                                <div className='crse-new-note-btn mt-8 pt-8 border-t border-[#D0D0D0]'>

                                                                    <div className='crse-take-note-area'>
                                                                        <form>
                                                                            <div className='crse-note-field mb-8'>
                                                                                <textarea name='notes' placeholder='Take new note' value={selectedNote.notes} onChange={handleValueChange} className='text-base border border-black p-3 w-full h-36 resize-none'></textarea>
                                                                            </div>
                                                                            <buton type="button" onClick={() => addNote()} className='w-full md:w-max cursor-pointer bg-tertiary hover:bg-black flex items-center justify-center px-8 h-10 2xl:h-16 text-white inter-600 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label="save note">Save Note</buton>
                                                                        </form>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </TabPanel>
                                                        <TabPanel>
                                                            <div className='crse-video-cntnt-ovrw'>
                                                                {transcript.length > 0 && (
                                                                    <ul className="mt-4 space-y-2">
                                                                        {transcript.map((sub, i) => (
                                                                            <li key={i} className="flex justify-between items-center bg-gray-100 p-2 rounded">
                                                                                <span>Transcript:</span>
                                                                                <button
                                                                                    className="bg-green-600 text-white px-3 py-1 rounded"
                                                                                    onClick={() => downloadSubtitle(sub.link, sub.language, i)}
                                                                                >
                                                                                    Download
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                    </ul>
                                                                )}
                                                            </div>
                                                        </TabPanel>
                                                    </div>
                                                </div>
                                            </Tabs>
                                        </div>
                                    </div>
                                )}


                                <div className='dash-course-wrap mt-2 md:mt-3 lg-mt-5'>
                                    <div className='course-slider-wrap mt-2 lg:pl-12 md:pl-6 md:pr-6 pl-0 pr-0 lg:pr-0 pb-5'>
                                        <div className='xl:mt-2 lg:mt-2 md:mt-2 mt-4'>
                                            <h4 class="text-lg lg:text-xl inter-600 text-black lg:pl-0 pl-6 lg:pr-0 pr-6 md:-mb-8 mb-3">Course</h4>
                                            <div className='course-slider-row pb-3 flex overflow-hidden'>
                                                <div className='course-slider dtl-course-slider overflow-hidden pt-4 md:pt-12 md:pl-2 md:pb-7 pb-3 w-full'>
                                                    <Swiper
                                                        ref={swiperRef}
                                                        spaceBetween={10}
                                                        slidesPerView={1.5}
                                                        slidesPerGroup={4}
                                                        freeMode={true}
                                                        navigation={true}
                                                        speed={1500}
                                                        mousewheel={true}
                                                        modules={[Navigation, FreeMode]}
                                                        breakpoints={{
                                                            640: {
                                                                slidesPerView: 1.5,
                                                                spaceBetween: 10,
                                                            },
                                                            768: {
                                                                slidesPerView: 3.5,
                                                                spaceBetween: 10,
                                                            },
                                                            1024: {
                                                                slidesPerView: 4.5,
                                                                spaceBetween: 20,
                                                            },
                                                            1400: {
                                                                slidesPerView: 5.5,
                                                            },
                                                        }}
                                                        className='overflow-visible'
                                                    >
                                                        {pedagogy.map((value, index) => (
                                                            <SwiperSlide key={index}>
                                                                <div>
                                                                    <a href='#' onClick={(e) => {e.preventDefault(); nextPedagogy(index)}} aria-label={value.title} className={`cursor-pointer ${selectedIndex === index ? 'course-card-active' : ''} course-card flex flex-col justify-between ${selectedIndex === index ? 'bg-[#58C181]' : 'bg-[#6E3174]'} min-h-52 2xl:min-h-[230px] rounded-3xl py-6 lg:pl-5 xl:pl-7 pl-5 lg:pr-5 xl:pr-10 pr-5 block hover:scale-x-[1.04] hover:scale-y-[1.09] hover:shadow-lg transition-all duration-300 ease-in-out`}>
                                                                        <div className='course-icon mb-4'>
                                                                            <img className='lg:w-6 h-6 2xl:w-8' src={pedagogyLearning[value.id] === 1 ? '../images/greentick.svg' : '../images/book-w.svg'} alt='greentick' />
                                                                        </div>
                                                                        <p className='lg:text-lg 2xl:text-xl lg:leading-6 text-white inter-600'>{value.pedagogy_seq_no}. {value.title}</p>
                                                                        <div className='play-icon-wrap'>
                                                                            <img className='play-icon w-20 mx-auto' src='../images/play-icon.svg' alt='play icon' />
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </SwiperSlide>
                                                        ))}
                                                    </Swiper>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}

                        <div className='lg:py-10 md:py-8 py-0 lg:px-12 px-6 course-navigate-btns flex flex-wrap justify-between'>
                            <button onClick={() => getPrevModule()} className='w-full md:w-max mb-4 md:mb-0 cursor-pointer bg-secondary hover:bg-black flex items-center justify-center px-6 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label="Previous Lesson">Previous Lesson</button>
                            <button onClick={() => getNextModule()} className='w-full md:w-max cursor-pointer bg-secondary hover:bg-black flex items-center justify-center px-6 h-10 2xl:h-16 text-white inter-700 text-base 2xl:text-2xl rounded-3xl lg:rounded-full transition duration-300 button-shadow' aria-label="Next Lesson">Next Lesson</button>
                        </div>
                    </div>
                )}
            </div>
            {/* In chat-bbl-text we need to add class "active-chat" on click chat bubble */}
            <div className={shakeActive ? 'chat-bbl-text fixed bottom-7 right-24 z-50' : 'chat-bbl-text fixed bottom-7 right-24 z-50'}>
                <p className='text-xs inter-500 text-white bg-[#620b57] py-3 px-3 rounded-md relative'>
                    Ask Me Anything
                </p>
            </div>
            <df-messenger
                project-id="qlitex"
                agent-id="5e294f2b-c5c9-49a4-9170-20db654a8460"
                language-code="en"
                max-query-length="-1"
                allow-feedback="all">
                <df-messenger-chat-bubble
                    chat-title="Q-Bot" chat-icon="https://storage.googleapis.com/q-lite/Icon-01.svg" chat-title-icon="https://storage.googleapis.com/mediajenie/QLITE_Logo-01.svg">
                </df-messenger-chat-bubble>
            </df-messenger>
            {popupVisible && <SurveyPopup onClose={handleClose} questions={allSurvey} />}

        </>
    );
}